export const environment = {
  production: true,
  version: '2.23.1',
  appConfigUrl: 'assets/config/app.config.json',
  dashboardIds: {
    admin: {
      de: '54e0cda8-e518-41e1-aa90-b69a0a34cab4',
      en: '21697b7a-e6c7-4a23-9439-51c29bb416f5',
    },
    measure: {
      de: '77545f7b-48cd-4a60-935a-c481a3d30c8e',
      en: '65fe1c51-18d5-4268-bfbd-9a2c9100a6a4',
    },
  },
  webKioskUrl: 'https://aims.spaceforce.one/',
  Email: {
    technicalEmail: 'support@aims-app.com',
    systemEmail: 'support@aims-app.com',
  },
  notification: {
    pollingIntervalFocusedMs: 15000,
    pollingIntervalBlurredMs: 60000,
  },
  defaultLanguage: 'de',
};
